import styles from './Actions.module.css'

// BoardUI 0.5.9 Chip: compact, rounded rectangular semantic labels. Tone and
// density come from the existing Badge facade; colors follow Wager's theme.
export function BoardChip({ tone = 'neutral', compact = false, className = '', ...props }) {
  return <span {...props} className={[
    styles.chip, styles[`chip${tone[0].toUpperCase()}${tone.slice(1)}`],
    compact ? styles.chipCompact : '', className,
  ].filter(Boolean).join(' ')} />
}
